import { LINKS } from "../constants/camvioLinks";

const ACCOUNT = "account";
const ACTIVATE = "activate";
const AGRONOMIST_DASHBOARD = "agronomist-dashboard";
const AGRONOMISTS = "agronomists";
const AUTH = "auth";
const COLLABORATORS = "collaborators";
const CURRENT = "current";
const DASHBOARD = "dashboard";
const EDIT = "edit";
const EMAIL = "email";
const EQUIPMENTS = "equipments";
const FARMERS = "farmers";
const FIELDS = "fields";
const FORGOT_PASSWORD = "forgot-password";
const GO_BACK_TO_CAMVIO = "go-back-to-camvio";
const HISTORICAL = "historical";
const INBOX = "inbox";
const INSTRUCTIONS = "instructions";
const LOGIN = "login";
const MACHINERIES = "machineries";
const NEW = "new";
const NEWS_FEED = "news-feed";
const NOTIFICATIONS = "notifications";
const OSDE_APPLICATIONS = "osde-applications";
const PASSWORD_RECOVERY = "password-recovery";
const PROFILE = "profile";
const REGISTER = "register";
const REPORT = "report";
const SENT = "sent";
const SETTINGS = "settings";
const SMS = "sms";
const SYNC = "sync";
const TERMS = "terms";
const SPD_INVOICES = "spd-invoices";
const TWO_FACTOR = "two-factor-authentication";
const UNAUTHORIZED = "unauthorized-error403";
const USERS = "users";
const WELL_KNOWN = ".well-known";

export const RoutesSegments = {
  ACCOUNT,
  ACTIVATE,
  AGRONOMIST_DASHBOARD,
  AGRONOMISTS,
  AUTH,
  COLLABORATORS,
  CURRENT,
  DASHBOARD,
  EDIT,
  EMAIL,
  EQUIPMENTS,
  FARMERS,
  FIELDS,
  FORGOT_PASSWORD,
  GO_BACK_TO_CAMVIO,
  HISTORICAL,
  INBOX,
  INSTRUCTIONS,
  LOGIN,
  MACHINERIES,
  NEW,
  NEWS_FEED,
  NOTIFICATIONS,
  OSDE_APPLICATIONS,
  PASSWORD_RECOVERY,
  PROFILE,
  REGISTER,
  REPORT,
  SENT,
  SETTINGS,
  SMS,
  SYNC,
  TERMS,
  TWO_FACTOR,
  UNAUTHORIZED,
  USERS,
  WELL_KNOWN,
};

export const paths = {
  agronomistDashboard: `/${AGRONOMIST_DASHBOARD}`,
  agronomists: {
    all: `/${AGRONOMISTS}/*`,
    index: `/${AGRONOMISTS}`,
    one: (id) => `/${AGRONOMISTS}/${id}`,
  },
  collaborators: {
    all: `/${COLLABORATORS}/*`,
    index: `/${COLLABORATORS}`,
    one: (id) => `/${COLLABORATORS}/${id}`,
  },
  dashboardKyd: `/${DASHBOARD}`,
  equipments: {
    all: `/${EQUIPMENTS}/*`,
    edit: (id) => `/${EQUIPMENTS}/${id}/${EDIT}`,
    index: `/${EQUIPMENTS}`,
    new: `/${EQUIPMENTS}/${NEW}`,
    one: (id) => `/${EQUIPMENTS}/${id}`,
  },
  farmerReport: `/${REPORT}`,
  farmers: {
    all: `/${FARMERS}/*`,
    index: `/${FARMERS}`,
    one: (id) => `/${FARMERS}/${id}`,
  },
  fields: {
    all: `/${FIELDS}/*`,
    index: `/${FIELDS}`,
    new: `/${FIELDS}/${NEW}`,
    one: (id) => `/${FIELDS}/${id}`,
  },
  field: {
    index: (id) => `/${FIELDS}/${id}`,
    current: (id) => `/${FIELDS}/${id}/${CURRENT}`,
    historical: (id) => `/${FIELDS}/${id}/${HISTORICAL}`,
  },
  forgotPassword: `/${AUTH}/${FORGOT_PASSWORD}`,
  home: "/",
  icognitoOpekepe: `/${AUTH}/${GO_BACK_TO_CAMVIO}`,
  inbox: {
    index: `/${INBOX}/${SENT}`,
    sms: `/${INBOX}/${SENT}/${SMS}`,
    email: `/${INBOX}/${SENT}/${EMAIL}`,
  },
  instructions: `/${INSTRUCTIONS}`,
  spdInvoices: `/${SPD_INVOICES}`,
  login: `/${AUTH}/${LOGIN}`,
  newsFeed: `/${NEWS_FEED}`,
  passwordRecovery: `/${PASSWORD_RECOVERY}/:uid/:token`,
  privacyPolicy: LINKS.PRIVACY_POLICY,
  osdeApplications: {
    one: (id) => `/${OSDE_APPLICATIONS}/${id}`,
    index: `/${OSDE_APPLICATIONS}`,
    sync: `/${OSDE_APPLICATIONS}/${SYNC}`,
  },
  opekepeLogin: (isDev) => LINKS.OPEKEPE_LOGIN(isDev),
  register: `/${AUTH}/${REGISTER}`,
  settings: {
    all: `/${SETTINGS}/*`,
    account: `/${SETTINGS}/${ACCOUNT}`,
    index: `/${SETTINGS}`,
    machineries: `/${SETTINGS}/${MACHINERIES}`,
    notifications: `/${SETTINGS}/${NOTIFICATIONS}`,
    profile: `/${SETTINGS}/${PROFILE}`,
  },
  terms: LINKS.TERMS_CONDITIONS,
  twoFactorAuthentication: `/${TWO_FACTOR}`,
  unauthorized: `/${UNAUTHORIZED}`,
  userActivation: `/${USERS}/${ACTIVATE}/:uid/:token`,
};

const PUBLIC_URLS = [
  `/${AUTH}`,
  `/${USERS}/${ACTIVATE}`,
  `/${PASSWORD_RECOVERY}`,
  `/${WELL_KNOWN}`,
];
export const checkIfPublicPage = () => {
  const pathName = window.location.pathname;

  return PUBLIC_URLS.some((url) => pathName.startsWith(url));
};
